jQuery(document).ready(function ($) {

	$('body').on('click', '.oab-talks-replay-grid__btn', function (){
		if($(this).hasClass('oab-talks-replay-grid__btn-hidden')) {
			return;
		}
		$(this).closest('.oab-talks-replay-grid__content').find('.oab-talks-replay-grid__video').css("display", "block");
	});

	$('body').on('click', '.oab-talks-replay-grid__mask', function (){
		let iframe = $(this).closest('.oab-talks-replay-grid__content').find('iframe');

		if (iframe.length) {
			let src = iframe.attr('src');
			iframe.attr('src', '');
			iframe.attr('src', src)
		}
			$('.oab-talks-replay-grid__video').hide();
		})
	});


